export const downloadCsvFile = (blobData, filename = "filename") => {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(
      new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), blobData], {
        type: "text/csv;charset=utf-8-bom",
      }),
      filename,
    );
  } else {
    const url = URL.createObjectURL(
      new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), blobData], {
        type: "text/csv;charset=utf-8-bom",
      }),
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const downloadFile = (blobData, filename = "filename") => {
  const type = blobData.type;

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(
      new Blob([blobData], {
        type,
      }),
      filename,
    );
  } else {
    const url = URL.createObjectURL(
      new Blob([blobData], {
        type,
      }),
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const delay = ms => new Promise(res => setTimeout(res, ms));

export const downloadXslsFile = (blobData, filename = "filename") => {
  const type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml";

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(
      new Blob([blobData], {
        type,
      }),
      filename,
    );
  } else {
    const url = URL.createObjectURL(
      new Blob([blobData], {
        type,
      }),
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
